/**
 * Itens de manutenção padrão (plataforma + espelho no app).
 * Customizações da fazenda ficam em localStorage (ver customMaintenanceItems.js).
 */
export const MAINTENANCE_ITEM_CATEGORIES = [
  { id: "engine_oil", label: "Troca de óleo do motor" },
  { id: "transmission_oil", label: "Troca de óleo da transmissão" },
  { id: "hydraulic_oil", label: "Troca de óleo hidráulico" },
  { id: "differential_oil", label: "Troca de óleo do diferencial" },
  { id: "brake_system", label: "Sistema de freio" },
  { id: "brake_fluid", label: "Fluido de freio" },
  { id: "coolant", label: "Fluido de arrefecimento" },
  { id: "air_filter", label: "Filtro de ar" },
  { id: "cabin_filter", label: "Filtro de cabine" },
  { id: "fuel_filter", label: "Filtro de combustível" },
  { id: "oil_filter", label: "Filtro de óleo" },
  { id: "hydraulic_filter", label: "Filtro hidráulico" },
  { id: "grease", label: "Lubrificação / graxa" },
  { id: "belts", label: "Correias" },
  { id: "tires", label: "Pneus / calibragem" },
  { id: "battery", label: "Bateria / elétrico" },
  { id: "clutch", label: "Embreagem" },
  { id: "suspension", label: "Suspensão" },
  { id: "general_inspection", label: "Revisão geral" },
];

export const SCHEDULE_BY_HOURS = "hours";
export const SCHEDULE_BY_KM = "km";
export const SCHEDULE_BY_DATE = "date";

/** Modo da UI: medidor da máquina (h/km automático) ou data. */
export const SCHEDULE_MODE_METER = "meter";
export const SCHEDULE_MODE_DATE = "date";
